import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import Input from './Input'

import './index.scss'

/**
 * @example
 * <Checkbox
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Checkbox" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   required
 * >
 *   <Checkbox.Input
 *     id="someField-0"
 *     label={<FormattedMessage id="SomeOption.ABC" defaultMessage="Option ABC" />}
 *     name="someField"
 *     value="ABC"
 *   />
 *   <Checkbox.Input
 *     id="someField-1"
 *     label={<FormattedMessage id="SomeOption.DEF" defaultMessage="Option DEF" />}
 *     name="someField"
 *     value="DEF"
 *   />
 *   <Checkbox.Input
 *     id="someField-2"
 *     label={<FormattedMessage id="SomeOption.123" defaultMessage="Option 123" />}
 *     name="someField"
 *     value="123"
 *   />
 * </Checkbox>
 */
const Checkbox = ({ children, className, ...props }: any) => (
  <Field {...props} className={cn('form__checkbox', className)}>
    {children}
  </Field>
)

Checkbox.Input = Input
Checkbox.displayName = 'Checkbox'
Checkbox.propTypes = { ...propTypes, children: PropTypes.node }
Checkbox.defaultProps = { ...defaultProps }
export default Checkbox
